export const FaqListPublish = () => {
    return (
        <>
            <div className="fiter_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">FAQ 정보</h3>
                    <div className="filter_toolbar">
                        <button className="btn btn-info">저장</button>
                    </div>
                </div>
                <div className="faq_box_outer">
                    <div className="faq_box box1">
                        <img src={process.env.PUBLIC_URL + "/assets/images/icon_faq1.png"} alt="" />
                        <div className="text">찾는 답변이 없다면?</div>
                    </div>
                    <div className="faq_box box2">
                        <div className="left">
                            <h5>MDS 문의</h5>
                            <img src={process.env.PUBLIC_URL + "/assets/images/icon_qna.png"} alt="" />
                        </div>
                        <div className="right">
                            <select className="form-select">
                                <option>설치문의 정보</option>
                            </select>
                            <select className="form-select">
                                <option>교환 가능한가요?</option>
                            </select>
                        </div>
                    </div>
                    <div className="faq_box box3">
                        <div className="left">
                            <h5>MDS테크로 문의하세요</h5>
                            <ul>
                                <li><img src={process.env.PUBLIC_URL + "/assets/images/icon_faq31.png"} alt="" />es@mdstech.co.kr</li>
                                <li><img src={process.env.PUBLIC_URL + "/assets/images/icon_faq32.png"} alt="" />031-000-0000</li>
                            </ul>
                        </div>
                        <div className="right">
                            <img src={process.env.PUBLIC_URL + "/assets/images/icon_faq3.png"} alt="" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="fiter_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">자주 묻는 질문 검색</h3>
                    <div className="filter_toolbar">
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <div className="frm_row justify-content-start">
                            <label for="" className="form-label frm_label">유형</label>
                            <div className="frm_row justify-content-start align-items-center">
                                <div className="tag_outer">
                                    <div className="tag_inputbox">
                                        <label>설치</label>
                                        <input type="text" className="form-control p-0" value={"설치"} />
                                        <div className="tag_toolbar">
                                            <button className="btn btn-link p-0"><img src={process.env.PUBLIC_URL + "/assets/images/icon_edittoken.png"} alt="" /></button>
                                            <button className="btn btn-link p-0 m-0"><img className="m-0" src={process.env.PUBLIC_URL + "/assets/images/icon_deltoken.png"} alt="" /></button>
                                        </div>
                                    </div>
                                    <div className="tag_inputbox active">
                                        <input type="text" className="form-control p-0" value={"라이선스 인증"} />
                                        <label>라이선스 인증</label>
                                        <div className="tag_toolbar">
                                            <button className="btn btn-link p-0"><img src={process.env.PUBLIC_URL + "/assets/images/icon_edittoken.png"} alt="" /></button>
                                            <button className="btn btn-link p-0 m-0"><img className="m-0" src={process.env.PUBLIC_URL + "/assets/images/icon_deltoken.png"} alt="" /></button>
                                        </div>
                                    </div>
                                    <div className="tag_inputbox blue">
                                        <input type="text" className="form-control p-0" value={"라이선스 인증"} />
                                        <label>라이선스 인증</label>
                                        <div className="tag_toolbar">
                                            <button className="btn btn-link p-0"><img src={process.env.PUBLIC_URL + "/assets/images/icon_edittoken.png"} alt="" /></button>
                                            <button className="btn btn-link p-0 m-0"><img className="m-0" src={process.env.PUBLIC_URL + "/assets/images/icon_deltoken.png"} alt="" /></button>
                                        </div>
                                    </div>
                                    <div className="tag_inputbox disabled">
                                        <label>설치</label>
                                        <input type="text" className="form-control p-0" value={"설치"} />
                                        <div className="tag_toolbar">
                                            <button className="btn btn-link p-0"><img src={process.env.PUBLIC_URL + "/assets/images/icon_edittoken_disabled.png"} alt="" /></button>
                                            <button className="btn btn-link p-0 m-0"><img src={process.env.PUBLIC_URL + "/assets/images/icon_deltoken_disabled.png"} alt="" /></button>
                                        </div>
                                    </div>
                                    <button className="btn btn-info p-0 w-30px h-30px"><img className="m-0" src={process.env.PUBLIC_URL + "/assets/images/icon_plus.png"} alt="" /></button>
                                </div>
                            </div>
                        </div>
                        <div className="frm_row search justify-content-start">
                            <label for="" className="form-label frm_label">날짜</label>
                            <select className="form-select">
                                <option>대상</option>
                            </select>
                            <input type="text" className="form-control me-0" placeholder="글씨를 입력 했을 때" />
                            <button className="btn btn-info btn_search">
                                <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt="" />조회
                            </button>
                        </div>
                    </div>
                    <div className="col-6">
                    </div>
                </div>
            </div>

            <div className="content_wrap">
                <div className="table_top">
                    <h6 className="table_stats">자주 묻는 질문 목록(<span>19</span>건)</h6>
                    <div className="table_toolbar">
                        <button className="btn btn-dark w-80px">추가</button>
                        <button className="btn btn-outline-dark w-100px px-0"><img src={process.env.PUBLIC_URL + "/assets/images/icon_cross.png"} alt="" />선택삭제</button>
                    </div>
                </div>

                <div className="table_scroll">
                    <table className="table table-bordered my_table">
                        <thead>
                            <tr>
                                <th rowSpan={2} style={{ width: "4.4%" }}>
                                    <div className="checkbox_outer">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                        />
                                    </div>
                                </th>
                                <th style={{ width: "7.5%%" }} rowSpan={2}>N0</th>
                                <th style={{ width: "10.06" }} rowSpan={2}>유형</th>
                                <th style={{ width: "22.64%" }} colSpan={2}>제품</th>
                                <th style={{ width: "42.1%" }} rowSpan={2}>제목</th>
                                <th rowSpan={2}>구분</th>
                            </tr>
                            <tr>
                                <th style={{ width: "11.32%" }}>벤더</th>
                                <th style={{ width: "11.32%" }}>카테고리</th>
                            </tr>
                        </thead>
                        <tbody>
                            {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((item, index) => (
                                <tr className={item == 8 ? "" : "lightblue"}>
                                    <td className="text-center">
                                        <div className="checkbox_outer"><input
                                            className="form-check-input"
                                            type="checkbox"
                                            checked={item == 8 ? false : true}
                                        /></div>
                                    </td>
                                    <td className="text-center">{index + 1}</td>
                                    <td className="text-center">설치</td>
                                    <td className="text-center">MS</td>
                                    <td className="text-center">Win11</td>
                                    <td>오프라인 전화 인증은 어떻게 하나요?</td>
                                    <td className="text-center">공지</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}